/* eslint-disable @typescript-eslint/no-explicit-any */
'use client'
import Cookies from 'js-cookie';

export const GET = async ({ url, accept }: { url: string, accept?: string }): Promise<any> => {
    const token = await Cookies.get('token') || '';
    const locale = await Cookies.get('language') || 'en';

    const response = await fetch(`${process.env.URI}${url}`, {
        method: 'GET',
        headers: {
            'accept': accept || 'application/json',
            'Content-Type': 'application/json',
            'Authorization': token !== '' ? `Bearer ${token}` : '',
            'Accept-Language': locale
        }
    });
    return response.json();
};


